import executeCallbacks from './execute-callbacks';
import { isFunction } from './asserts';
import cn from './cn';
function mergeProps(...args) {
    const result = Object.assign({}, args[0]);
    for (let i = 1; i < args.length; i++) {
        const props = args[i];
        for (const key in props) {
            const a = result[key];
            const b = props[key];
            if (isFunction(a) && isFunction(b) && key.startsWith('on')) {
                result[key] = executeCallbacks(a, b);
            }
            else if (key === 'style') {
                result[key] = mergeProps(a, b);
            }
            else if (key === 'className' || key === 'UNSAFE_className') {
                result[key] = cn(a, b);
            }
            else {
                result[key] = b !== null && b !== void 0 ? b : a;
            }
        }
    }
    return result;
}
export default mergeProps;
//# sourceMappingURL=merge-props.js.map